import * as Sentry from "@sentry/react";
import { startSentryTransaction } from "./utils/sentryTransaction";
import mainStore from "./MainStore/store";
import axios from "axios";

export const SentryCaptureException = (exception, tags = {}) => {
  try {
    if (process.env.NODE_ENV === "production") {
      const { username } = mainStore.getState().globalReducer;
      const log = exception?.stack
        ? typeof exception.stack === "string"
          ? exception.stack
          : JSON.stringify(exception.stack)
        : JSON.stringify(exception);

      const formData = new FormData();
      formData.append("username", username);
      formData.append("log", log);

      axios
        .post(`/users/log_frontend_errors/`, formData)
        .then(() => {})
        .catch((err) => console.log(err));

      // Start a forced-sampled transaction for this crash capture
      const txn = startSentryTransaction("frontend_crash_capture", {
        op: "error.capture",
        forceCapture: true,
        data: { reason: exception?.message }
      });

      const hints = {
        level: "error",
        tags: {
          ...tags,
          force_capture: "true",
          crash_transaction: txn?.traceId
        }
      };
      try {
        Sentry.captureException(exception, hints);
        txn && txn.setStatus("internal_error");
      } finally {
        txn && txn.finish();
      }
    }
  } catch (error) {
    console.log("Err While Capture Exception", error);
  }
};
